function capitalize(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}
function getTimeago(t){
	let x,e,s,f=((Intl && Intl.RelativeTimeFormat) ? new Intl.RelativeTimeFormat('pt-BR',{numeric:"always"}) : null);
	x = [
		{n:"ano",l:31536000,u:'year'},
		{n:"mês",l:2592000,u:'month',p:"meses"},
		{n:"semana",l:604800,u:'week'},
		{n:"dia",l:86400,u:'day'},
		{n:"hora",l:3600,u:'hour'},
		{n:"minuto",l:60,u:'minute'},
	]
	for(let i=0;i<x.length;i++){
		e=x[i];
		s=Math.floor((new Date().getTime() - t)/1000);
		var n=Math.floor(s/e.l);
		if(n>=1){
			return f ? capitalize(f.format(n*-1,e.u)) : "Há "+n+" "+(n>=2 ? (e.p || e.n+'s') : e.n);
		}
	}
	return "Agora";
};
(function(){
	var timeagos = document.querySelectorAll(".news-wrapper .item .timeago,.widget .timeago, .news-list .timeago");
	[].forEach.call(timeagos,(elem) => {
		var ts = elem.getAttribute("data-ts");
		elem.textContent = getTimeago(parseInt(ts)*1000);
		elem.classList.add("timeago--loaded");
	});
})();
(function(){
	var diasDaSemana = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];
	let meses = ["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"];
	var elem = document.querySelector(".header__datelocation");
	if(elem){
		let dayOfWeek = new Date().getDay();
		let day = new Date().getDate();
		let month = new Date().getMonth();
		let year = new Date().getFullYear();
		console.log([day,month,year]);
		elem.textContent = "Porto Alegre, "+diasDaSemana[dayOfWeek].toLowerCase()+", "+day+" de "+meses[month].toLowerCase()+" de "+year;
	}
})();
import 'js/mobile/common/smart-fixed-header.js';
import 'js/plugin/multi-level-push-menu.jquery.js';
window.addEventListener("load",function(){
	$('.mpl').multilevelPushMenu();
});